export default __webpack_public_path__ + "static/media/foundation-nft-logo-white.21679094.svg";